<section
  class="bannerMain"
  aria-roledescription="carrusel"
  aria-label="Promociones"
  (pointerdown)="onPointerDown($event)"
  (pointerup)="onPointerUp($event)"
  (pointercancel)="onPointerUp($event)"
>
  @for (banner of banners(); track banner.id; let i = $index) {
  <div
    class="slide"
    [class.active]="i === current()"
    [attr.aria-hidden]="i !== current()"
    [attr.inert]="i !== current() ? '' : null"
    role="group"
    aria-roledescription="slide"
  >
    <picture class="contentImage">
      <source [media]="mobileQuery" [srcset]="banner.mobile_background" />
      <img
        [src]="banner.background"
        alt="Promoción"
        [attr.fetchpriority]="i === 0 ? 'high' : null"
        [attr.loading]="i === 0 ? 'eager' : 'lazy'"
        decoding="async"
      />
    </picture>
    <div class="container">
      <div class="row">
        <div class="col-lg-6 textBanner" data-aos="fade-up">
          <div class="title" [innerHTML]="banner.name | safehtml"></div>
          <div [innerHTML]="banner.description | safehtml" class="description"></div>
          @if (banner.blank) {
          <a
            [href]="banner.link"
            target="_blank"
            class="btn btnTracsa btnYellowWhite btnBannerHome"
            >{{ banner.text_button }}</a
          >
          } @else {
          <a [href]="banner.link" class="btn btnTracsa btnYellowWhite btnBannerHome">{{
            banner.text_button
          }}</a>
          }
        </div>
      </div>
    </div>
  </div>
  }

  @if (hasMany()) {
  <button type="button" class="bannerArrow bannerPrev" aria-label="Anterior" (click)="prev()"></button>
  <button type="button" class="bannerArrow bannerNext" aria-label="Siguiente" (click)="next()"></button>
  <ul class="bannerDots">
    @for (banner of banners(); track banner.id; let i = $index) {
    <li [class.active]="i === current()">
      <button
        type="button"
        [attr.aria-label]="'Ir al banner ' + (i + 1)"
        [attr.aria-current]="i === current() ? 'true' : null"
        (click)="goTo(i)"
      ></button>
    </li>
    }
  </ul>
  }
</section>
